import { render } from "./AboutUs.vue?vue&type=template&id=4ec31daa&scoped=true"
const script = {}

import "./AboutUs.vue?vue&type=style&index=0&id=4ec31daa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ec31daa"]])

export default __exports__